import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import Content from './Content';

const queryClient = new QueryClient();

interface NewsletterFeedBannerProps {
  currentUserAccessLevel: number;
  feedType: string;
  gdpr: boolean;
  gdprColorScheme: string;
  isLoggedIn: boolean;
  newsletterId: number;
}

const NewsletterFeedBanner = ({
  currentUserAccessLevel,
  feedType,
  gdpr,
  gdprColorScheme,
  isLoggedIn,
  newsletterId,
}: NewsletterFeedBannerProps) => (
  <QueryClientProvider client={queryClient}>
    <Content
      currentUserAccessLevel={currentUserAccessLevel}
      isLoggedIn={isLoggedIn}
      feedType={feedType}
      gdpr={gdpr}
      gdprColorScheme={gdprColorScheme}
      newsletterId={newsletterId}
    />
  </QueryClientProvider>
);

export default NewsletterFeedBanner;
